function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP licence number
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import { email } from '../../actions/index';
import TextInput from '../text-input/TextInput';
import { FIELDS } from '../../data/Data';
import './Email.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export class Email extends React.Component {
  render() {
    const {
      email,
      setEmail
    } = this.props;
    return /*#__PURE__*/_jsx(TextInput, {
      autoComplete: "email",
      handleChange: setEmail,
      onBlur: setEmail,
      label: "Email",
      name: "email",
      section: "personal-details"
      // $FlowFixMe
      ,
      values: {
        email
      },
      type: "email",
      inputMode: "email"
    });
  }
}
_defineProperty(Email, "defaultProps", {
  email: {
    ...FIELDS.email
  }
});
const mapStateToProps = ({
  email
}) => {
  return {
    email
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setEmail: value => {
      dispatch(email(value));
    }
  };
};
const VisibleEmail = connect(mapStateToProps, mapDispatchToProps)(Email);
export default VisibleEmail;